/**
 * @generated SignedSource<<2fb676ceb84c860fa47157b381044309>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: nx generate-api-types
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AssetHistoryPeriod = "DAY" | "FIVE_YEARS" | "MONTH" | "SIX_MONTHS" | "WEEK" | "YEAR";
export type AssetDetailsViewQuery$variables = {
  assetHistoryPeriod?: AssetHistoryPeriod | null | undefined;
  id?: string | null | undefined;
};
export type AssetDetailsViewQuery$data = {
  readonly assetById: {
    readonly __typename: string;
    readonly description: string | null | undefined;
    readonly distributionPolicy?: string | null | undefined;
    readonly dividendPerShare?: PrecisionFloat | null | undefined;
    readonly dividendPerShareYear?: number | null | undefined;
    readonly dividendYield?: number | null | undefined;
    readonly dividendYieldYear?: number | null | undefined;
    readonly earningsPerShare?: PrecisionFloat | null | undefined;
    readonly earningsPerShareYear?: number | null | undefined;
    readonly fundSize?: number | null | undefined;
    readonly history: ReadonlyArray<{
      readonly __typename: "AssetHistory";
      readonly close: PrecisionFloat | null | undefined;
      readonly time: TimeScalar | null | undefined;
    } | null | undefined> | null | undefined;
    readonly id: string;
    readonly isActive: boolean | null | undefined;
    readonly isBuyActive: boolean | null | undefined;
    readonly isSellActive: boolean | null | undefined;
    readonly isin?: string | null | undefined;
    readonly keyInformationDocuments?: ReadonlyArray<{
      readonly language: string | null | undefined;
      readonly url: string | null | undefined;
    }> | null | undefined;
    readonly legalUrl: string | null | undefined;
    readonly logoUrl: string | null | undefined;
    readonly marketCap: number | null | undefined;
    readonly monthlyVolatility: number | null | undefined;
    readonly name: string | null | undefined;
    readonly openHours?: {
      readonly lastCloseTime: TimeScalar | null | undefined;
      readonly lastOpenTime: TimeScalar | null | undefined;
      readonly nextChange: TimeScalar | null | undefined;
      readonly open: boolean | null | undefined;
      readonly wasOpenToday: boolean | null | undefined;
    } | null | undefined;
    readonly peRatio?: number | null | undefined;
    readonly peRatioYear?: number | null | undefined;
    readonly portfolio: {
      readonly assetBalance: PrecisionFloat | null | undefined;
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly assets: {
            readonly edges: ReadonlyArray<{
              readonly allocationPercentage: number | null | undefined;
              readonly assetBalance: PrecisionFloat | null | undefined;
              readonly averageBuyPrice: PrecisionFloat | null | undefined;
              readonly dailyReturn: ValueChange | null | undefined;
              readonly fiatBalance: PrecisionFloat | null | undefined;
              readonly fiatTotalStakedAmount: PrecisionFloat | null | undefined;
              readonly stakedBalance: ValueChange | null | undefined;
              readonly totalInvested: PrecisionFloat | null | undefined;
              readonly totalReturn: ValueChange | null | undefined;
            } | null | undefined> | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
      readonly fiatBalance: PrecisionFloat | null | undefined;
      readonly totalInvested: PrecisionFloat | null | undefined;
    } | null | undefined;
    readonly price: PrecisionFloat | null | undefined;
    readonly price52WeeksHigh: PrecisionFloat | null | undefined;
    readonly price52WeeksLow: PrecisionFloat | null | undefined;
    readonly priceChange1Month: ValueChange | null | undefined;
    readonly priceChange1Week: ValueChange | null | undefined;
    readonly priceChange1Year: ValueChange | null | undefined;
    readonly priceChange24Hours: ValueChange | null | undefined;
    readonly priceChange5Years: ValueChange | null | undefined;
    readonly priceDailyHigh: PrecisionFloat | null | undefined;
    readonly priceDailyLow: PrecisionFloat | null | undefined;
    readonly prices: ReadonlyArray<{
      readonly fiat: {
        readonly name: string | null | undefined;
        readonly symbol: string | null | undefined;
      } | null | undefined;
      readonly value: PrecisionFloat | null | undefined;
    }> | null | undefined;
    readonly provider?: string | null | undefined;
    readonly recommendation?: {
      readonly breakdown: ReadonlyArray<{
        readonly percentage: number | null | undefined;
        readonly type: string | null | undefined;
      } | null | undefined> | null | undefined;
      readonly totalCount: number | null | undefined;
    } | null | undefined;
    readonly replicationMethod?: string | null | undefined;
    readonly revenue?: PrecisionFloat | null | undefined;
    readonly revenueYear?: string | null | undefined;
    readonly symbol: string | null | undefined;
    readonly totalExpenseRatio?: number | null | undefined;
    readonly yearlyNetIncomes?: ReadonlyArray<{
      readonly period: string | null | undefined;
      readonly value: PrecisionFloat | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type AssetDetailsViewQuery = {
  response: AssetDetailsViewQuery$data;
  variables: AssetDetailsViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "assetHistoryPeriod"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isBuyActive",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isSellActive",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "legalUrl",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "symbol",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "logoUrl",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "value",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "marketCap",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceDailyHigh",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceDailyLow",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price52WeeksHigh",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "price52WeeksLow",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyVolatility",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange24Hours",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange1Week",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange1Month",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange1Year",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "priceChange5Years",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fiatBalance",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assetBalance",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalInvested",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetPortfoliosConnection",
  "kind": "LinkedField",
  "name": "portfolio",
  "plural": false,
  "selections": [
    (v26/*: any*/),
    (v27/*: any*/),
    (v28/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetPortfoliosEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Portfolio",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PortfolioAssetsConnection",
              "kind": "LinkedField",
              "name": "assets",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PortfolioAssetsEdge",
                  "kind": "LinkedField",
                  "name": "edges",
                  "plural": true,
                  "selections": [
                    (v27/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "averageBuyPrice",
                      "storageKey": null
                    },
                    (v26/*: any*/),
                    (v28/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "dailyReturn",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "stakedBalance",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "fiatTotalStakedAmount",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "allocationPercentage",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "totalReturn",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "period",
      "variableName": "assetHistoryPeriod"
    }
  ],
  "concreteType": "AssetHistory",
  "kind": "LinkedField",
  "name": "history",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "time",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "close",
      "storageKey": null
    },
    (v25/*: any*/)
  ],
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isin",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dividendYield",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dividendPerShare",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dividendYieldYear",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "dividendPerShareYear",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "peRatioYear",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "peRatio",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenue",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "revenueYear",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "concreteType": "AssetRecommendation",
  "kind": "LinkedField",
  "name": "recommendation",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalCount",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "AssetRecommendationBreakdown",
      "kind": "LinkedField",
      "name": "breakdown",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "percentage",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "concreteType": "HistoricalValue",
  "kind": "LinkedField",
  "name": "yearlyNetIncomes",
  "plural": true,
  "selections": [
    (v12/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "period",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v42 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/)
  ],
  "type": "StockAsset",
  "abstractKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "concreteType": "KeyInformationDocument",
  "kind": "LinkedField",
  "name": "keyInformationDocuments",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "language",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "url",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fundSize",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distributionPolicy",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "replicationMethod",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalExpenseRatio",
  "storageKey": null
},
v49 = [
  (v31/*: any*/),
  (v43/*: any*/),
  (v44/*: any*/),
  (v45/*: any*/),
  (v46/*: any*/),
  (v47/*: any*/),
  (v48/*: any*/)
],
v50 = {
  "kind": "InlineFragment",
  "selections": (v49/*: any*/),
  "type": "EtfAsset",
  "abstractKey": null
},
v51 = {
  "kind": "InlineFragment",
  "selections": (v49/*: any*/),
  "type": "EtcAsset",
  "abstractKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "concreteType": "MarketOpenHours",
  "kind": "LinkedField",
  "name": "openHours",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "open",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextChange",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "wasOpenToday",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastOpenTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastCloseTime",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v53 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/),
    (v52/*: any*/),
    (v37/*: any*/),
    (v36/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "earningsPerShare",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "earningsPerShareYear",
      "storageKey": null
    },
    (v40/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v41/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/)
  ],
  "type": "EquityStockAsset",
  "abstractKey": null
},
v54 = {
  "kind": "InlineFragment",
  "selections": [
    (v31/*: any*/),
    (v44/*: any*/),
    (v48/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v52/*: any*/),
    (v43/*: any*/)
  ],
  "type": "EquityEtfAsset",
  "abstractKey": null
},
v55 = {
  "kind": "InlineFragment",
  "selections": [
    (v44/*: any*/),
    (v48/*: any*/),
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    (v52/*: any*/),
    (v43/*: any*/)
  ],
  "type": "EquityEtcAsset",
  "abstractKey": null
},
v56 = [
  (v44/*: any*/),
  (v48/*: any*/),
  (v45/*: any*/),
  (v46/*: any*/),
  (v52/*: any*/)
],
v57 = {
  "kind": "InlineFragment",
  "selections": (v56/*: any*/),
  "type": "EquityComplexEtcAsset",
  "abstractKey": null
},
v58 = {
  "kind": "InlineFragment",
  "selections": (v56/*: any*/),
  "type": "EquityComplexEtfAsset",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AssetDetailsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assetById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Price",
            "kind": "LinkedField",
            "name": "prices",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Fiat",
                "kind": "LinkedField",
                "name": "fiat",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v42/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v57/*: any*/),
          (v58/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AssetDetailsViewQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "assetById",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Price",
            "kind": "LinkedField",
            "name": "prices",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Fiat",
                "kind": "LinkedField",
                "name": "fiat",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v9/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              },
              (v12/*: any*/)
            ],
            "storageKey": null
          },
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v42/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v57/*: any*/),
          (v58/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d9207f8ccab49e73abacb8cfcfdb4804",
    "id": null,
    "metadata": {},
    "name": "AssetDetailsViewQuery",
    "operationKind": "query",
    "text": "query AssetDetailsViewQuery(\n  $id: ID\n  $assetHistoryPeriod: AssetHistoryPeriod\n) {\n  assetById(id: $id) {\n    id\n    name\n    isActive\n    isBuyActive\n    isSellActive\n    legalUrl\n    symbol\n    logoUrl\n    price\n    prices {\n      fiat {\n        name\n        symbol\n        id\n      }\n      value\n    }\n    description\n    marketCap\n    priceDailyHigh\n    priceDailyLow\n    price52WeeksHigh\n    price52WeeksLow\n    monthlyVolatility\n    priceChange24Hours\n    priceChange1Week\n    priceChange1Month\n    priceChange1Year\n    priceChange5Years\n    __typename\n    portfolio {\n      fiatBalance\n      assetBalance\n      totalInvested\n      edges {\n        node {\n          assets {\n            edges {\n              assetBalance\n              averageBuyPrice\n              fiatBalance\n              totalInvested\n              dailyReturn\n              stakedBalance\n              fiatTotalStakedAmount\n              allocationPercentage\n              totalReturn\n            }\n          }\n        }\n      }\n    }\n    history(period: $assetHistoryPeriod) {\n      time\n      close\n      __typename\n    }\n    ... on StockAsset {\n      isin\n      dividendYield\n      dividendPerShare\n      dividendYieldYear\n      dividendPerShareYear\n      peRatioYear\n      peRatio\n      revenue\n      revenueYear\n      recommendation {\n        totalCount\n        breakdown {\n          percentage\n          type\n        }\n      }\n      yearlyNetIncomes {\n        value\n        period\n      }\n    }\n    ... on EtfAsset {\n      isin\n      keyInformationDocuments {\n        language\n        url\n      }\n      fundSize\n      distributionPolicy\n      replicationMethod\n      provider\n      totalExpenseRatio\n    }\n    ... on EtcAsset {\n      isin\n      keyInformationDocuments {\n        language\n        url\n      }\n      fundSize\n      distributionPolicy\n      replicationMethod\n      provider\n      totalExpenseRatio\n    }\n    ... on EquityStockAsset {\n      isin\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n      peRatio\n      peRatioYear\n      earningsPerShare\n      earningsPerShareYear\n      recommendation {\n        totalCount\n        breakdown {\n          percentage\n          type\n        }\n      }\n      revenue\n      revenueYear\n      yearlyNetIncomes {\n        value\n        period\n      }\n      dividendYield\n      dividendPerShare\n      dividendYieldYear\n      dividendPerShareYear\n    }\n    ... on EquityEtfAsset {\n      isin\n      fundSize\n      totalExpenseRatio\n      distributionPolicy\n      replicationMethod\n      provider\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n      keyInformationDocuments {\n        language\n        url\n      }\n    }\n    ... on EquityEtcAsset {\n      fundSize\n      totalExpenseRatio\n      distributionPolicy\n      replicationMethod\n      provider\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n      keyInformationDocuments {\n        language\n        url\n      }\n    }\n    ... on EquityComplexEtcAsset {\n      fundSize\n      totalExpenseRatio\n      distributionPolicy\n      replicationMethod\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n    }\n    ... on EquityComplexEtfAsset {\n      fundSize\n      totalExpenseRatio\n      distributionPolicy\n      replicationMethod\n      openHours {\n        open\n        nextChange\n        wasOpenToday\n        lastOpenTime\n        lastCloseTime\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "26ca92f259240836bb8712cce60019ea";

export default node;
